import React, { Component } from "react"
import { timeToInt, timeFromInt } from "time-number"
import FormSelectWrapper from "./FormSelectWrapper"

class TimePicker extends Component {
	propTypes: {
		end: React.PropTypes.string,
		format: React.PropTypes.number,
		defaultValue: React.PropTypes.any,
		start: React.PropTypes.string,
		step: React.PropTypes.number,
		value: React.PropTypes.any,
	}

	generateFormattedTime = time => {
		const { format } = this.props
		const ret = timeFromInt(time, false)

		if (format === 24) {
			return ret
		}

		const found = ret.match(/^(\d+):/)
		const hour = parseInt(found[1], 10)

		if (hour === 0) {
			return `${ret.replace(/^\d+/, "12")} AM`
		} else if (hour < 12) {
			return `${ret} AM`
		} else if (hour === 12) {
			return `${ret} PM`
		}

		const newHour = hour < 22 ? `0${hour - 12}` : (hour - 12).toString()

		return `${ret.replace(/^\d+/, newHour)} PM`
	}

	generateTimeRange = () => {
		const { end, start, step } = this.props
		const times = []
		const iend = timeToInt(end, false)

		for (let i = timeToInt(start, false); i <= iend; i += step * 60) {
			times.push(i)
		}

		return times
	}

	listTimeOptions = () => {
		return this.generateTimeRange().map(unformattedTime => {
			const formattedTime = this.generateFormattedTime(unformattedTime)

			return {
				key: unformattedTime,
				value: unformattedTime,
				label: formattedTime,
			}
		})
	}

	getData = () => {
		return this.refs.local.getData()
	}

	render() {
		const { defaultValue } = this.props
		const timeOptions = this.listTimeOptions()

		return (
			<FormSelectWrapper
				id="timePicker"
				selectOptions={timeOptions}
				defaultValue={defaultValue}
				ref="local"
			/>
		)
	}
}

export default TimePicker



// WEBPACK FOOTER //
// ./src/forms/TimePicker.js